import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";




@Injectable({
    providedIn: "root"
})
export class MotivazioneCancellazioneService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}MotivazioneCancellazione/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<any>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<any[]>(
            `${this.apiUrl}`            
        );
    }

    insert(s: any) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: any) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:any){
        if (!s.id)return this.insert(s);
        return this.update(s);
    }

}
